"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBreakpoint = void 0;

var _react = require("react");

var ScreenSizes = _interopRequireWildcard(require("../constants/layout/ScreenSizes"));

var _sizes = require("HubStyleTokens/sizes");

var GRID_BREAKPOINT_SMALL_INT = parseInt(_sizes.GRID_BREAKPOINT_SMALL, 10);
var GRID_BREAKPOINT_MEDIUM_INT = parseInt(_sizes.GRID_BREAKPOINT_MEDIUM, 10);
var GRID_BREAKPOINT_LARGE_INT = parseInt(_sizes.GRID_BREAKPOINT_LARGE, 10);
var GRID_BREAKPOINT_EXTRA_LARGE_INT = parseInt(_sizes.GRID_BREAKPOINT_EXTRA_LARGE, 10);

var useBreakpoint = function useBreakpoint(width) {
  return (0, _react.useMemo)(function () {
    if (width < GRID_BREAKPOINT_SMALL_INT) {
      return ScreenSizes.XS;
    } else if (width < GRID_BREAKPOINT_MEDIUM_INT) {
      return ScreenSizes.SM;
    } else if (width < GRID_BREAKPOINT_LARGE_INT) {
      return ScreenSizes.MD;
    } else if (width < GRID_BREAKPOINT_EXTRA_LARGE_INT) {
      return ScreenSizes.LG;
    } else {
      return ScreenSizes.XL;
    }
  }, [width]);
};

exports.useBreakpoint = useBreakpoint;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/hooks/useBreakpoint.js
// module id = 436
// module chunks = 209 210 211 212